'use client'

import React from 'react'
import { TooltipProvider } from 'sidecar-components/atoms/Tooltip'
import { ToastProvider } from '@/contexts/ToastContext'
import { DatadogProvider } from '@/components/DatadogProvider'

/**
 * Global providers for the Group app.
 *
 * Wraps the app with:
 *
 * - DatadogProvider: Initializes RUM and Browser Logs on non-localhost
 * - TooltipProvider: Manages tooltip functionality from sidecar-components
 * - ToastProvider: Manages toast notifications throughout the app
 *
 * `appType` is resolved at request time on the server (from APP_TYPE env) and
 * forwarded into DatadogProvider so the correct DD applicationId is selected
 * per portal — broker and group share one Docker image, so build-time
 * NEXT_PUBLIC_APP_TYPE alone cannot distinguish them.
 */
export function AppProviders({
  children,
  appType,
}: {
  children: React.ReactNode
  appType?: 'broker' | 'group'
}) {
  return (
    <DatadogProvider appType={appType}>
      <TooltipProvider>
        <ToastProvider>{children}</ToastProvider>
      </TooltipProvider>
    </DatadogProvider>
  )
}
